<template>
  <div v-loading="loading" v-if="conclusion.complex_exercises">
    <div class="subtitle">Комплексы упражнений:</div>

    <template v-if="conclusion.complex_exercises.length !== 0">

      <el-tabs v-model="selectedComplex" type="card" closable @tab-remove="removeComplex" class="tabs">
        <el-tab-pane
            v-for="(item, index) in conclusion.complex_exercises"
            :key="item.id"
            :label="item.name"
            :name="index.toString()"
        >
          {{ item.index }}
        </el-tab-pane>
      </el-tabs>

      <div class="exercises">
        <complex-item
            v-for="(item, index) of conclusion.complex_exercises[selectedComplex].data"
            :key="item.id"
            :index="index"
            :exercise.sync="item"
            @save="save"
            @remove="remove"
        />
        <complex-item
            :newItem="true"
            :index="0"
            :exercise="newItem"
            @save="saveNewItem"
        />
      </div>
    </template>
    <el-alert
        v-else
        :closable="false"
        class="noty-alert"
        title="Нет данных о комплексах"
        type="warning"
        style="margin-top: 5px;"
    />

  </div>
</template>

<script>
import ComplexItem from "@/components/visit/complexExercises/ComplexItem.vue"
import {mapActions, mapGetters} from "vuex"

export default {
  name: "ComplexExercises",
  components: {ComplexItem},
  data() {
    return {
      loading: false,
      selectedComplex: 0,
      newItem: {
        description: "",
        exercise_approach: "",
        exercise_time: "",
        files: [],
        name: "",
      }
    }
  },
  watch: {
    selectedComplex() {
      this.$forceUpdate()
    }
  },
  computed: {
    ...mapGetters("visit", {
          conclusion: "conclusion"
        }
    ),
  },
  methods: {
    ...mapActions({
      updateConclusion: "visit/UPDATE_CONCLUSION",
    }),
    saveNewItem() {
      // this.conclusion.push(this.newItem)
      this.conclusion.complex_exercises[this.selectedComplex].data.push(this.newItem)

      this.save()

      this.newItem = {
        description: "",
        exercise_approach: "",
        exercise_time: "",
        files: [],
        name: "",
      }
    },
    removeComplex(index) {
      // console.log(this.conclusion.complex_exercises)
      this.conclusion.complex_exercises[index].data = []
      this.save()
    },
    save() {
      this.loading = true
      this.updateConclusion(this.conclusion).then(() => {
        this.$notify.success({
          title: "Успешно",
          message: "Данные обновлены",
        })
      }).catch((response) => {
        this.$notify.error({
          title: "Ошибка 😕",
          message: response.response.data.message
        })
      }).finally(() => {
        this.loading = false
      })
    },
    remove(index) {
      this.conclusion.complex_exercises[this.selectedComplex].data.splice(index, 1)
      this.save()
    }
  }
}

</script>
<style lang="scss" scoped>
@import "@/assets/scss/custom-tab.scss";

.subtitle {
  margin-top: 24px;

  font-weight: 600;
  font-size: 20px;
  line-height: 26px;
  color: #111;
}

.exercises {
  margin-top: 10px;

  display: grid;
  grid-gap: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(294px, 2fr));
  //grid-column-gap: 24px;
}

.tabs {

  line-height: 1;
  vertical-align: middle;
  font-size: 0;

  /deep/ {
    .el-tabs__nav {
      display: flex;
      flex-wrap: wrap;
    }

    .el-tabs__item {
      margin-top: 2px;
      display: block;
    }
  }
}
</style>